var _linearGradient, _path, _linearGradient2, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleAnalytics(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: "64px",
    height: "64px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "EgRYQKvHI4BoRDmL4Qu6la",
    x1: 32,
    x2: 32,
    y1: 9,
    y2: 55,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a6dff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c822ff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#EgRYQKvHI4BoRDmL4Qu6la)",
    d: "M51,9h-9c-2.21,0-4,1.79-4,4v11H27c-2.21,0-4,1.79-4,4v10H13c-2.21,0-4,1.79-4,4v9 c0,2.21,1.79,4,4,4h38c2.21,0,4-1.79,4-4V13C55,10.79,53.21,9,51,9z M38,53H13c-1.1,0-2-0.9-2-2v-9c0-1.1,0.9-2,2-2h11 c0.55,0,1-0.45,1-1V28c0-1.1,0.9-2,2-2h11V53z M53,51c0,1.1-0.9,2-2,2H40V13c0-1.1,0.9-2,2-2h9c1.1,0,2,0.9,2,2V51z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "EgRYQKvHI4BoRDmL4Qu6lb",
    x1: 46.5,
    x2: 46.5,
    y1: 11,
    y2: 53,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6dc7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6abff"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#EgRYQKvHI4BoRDmL4Qu6lb)",
    d: "M53,13v38c0,1.1-0.9,2-2,2H40V13c0-1.1,0.9-2,2-2h9C52.1,11,53,11.9,53,13z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleAnalytics);
export default __webpack_public_path__ + "static/media/google-analytics.3d449dc2cc9a0e52c902702af2f55ee8.svg";
export { ForwardRef as ReactComponent };